import { type CSSProperties, type ReactElement } from 'react';

import styles from '@web/molecules/StatsBarChart/StatsBarChart.module.scss';

import { percent } from './StatsBarChart.utils';

interface Props {
    title: string | ReactElement;
    primaryValue: number;
    secondaryValue: number;
}

export const StatsBarChart = ({ title, primaryValue = 0, secondaryValue = 0 }: Props) => {
    const total = primaryValue + secondaryValue;
    const cssChartVariables = {
        '--cmp-stats-bar-chart-left-percentage': `${percent(primaryValue, total)}%`,
        '--cmp-stats-bar-chart-right-percentage': `${percent(secondaryValue, total)}%`,
    } as CSSProperties;

    return (
        <dl className={styles.StatsBarChart} style={cssChartVariables}>
            <dt>{title}</dt>
            <dd className={styles['left-chart']}>
                <span className={styles.points}>{primaryValue}</span>
                <aside className={styles['bar-container']}>
                    <span
                        className={`${styles.bar} ${
                            styles[primaryValue >= secondaryValue ? 'highest-stat' : 'lowest-stat']
                        }`}
                    />
                </aside>
            </dd>
            <dd className={styles['right-chart']}>
                <aside className={styles['bar-container']}>
                    <span
                        className={`${styles.bar} ${
                            styles[secondaryValue >= primaryValue ? 'highest-stat' : 'lowest-stat']
                        }`}
                    />
                </aside>
                <span className={styles.points}>{secondaryValue}</span>
            </dd>
        </dl>
    );
};
